export const errorLog = (error: string) => {
  console.log(error);
};
